import { BootstrapBrowserBuilder } from '@zg-rentals/rp-bootstrap-browser';
import { analytics } from './analytics';

const builder = new BootstrapBrowserBuilder('applications-renter-web', Number(process.env.NEXT_PUBLIC_BUILD_NUMBER))
  .withHostedAppLoggerOptions('rental-manager-api', process.env.NEXT_PUBLIC_LOG_LEVEL)
  .withOnRegister(analytics.initialize);

if (process.env.NEXT_PUBLIC_DD_APP_ID && process.env.NEXT_PUBLIC_DD_CLIENT_TOKEN) {
  builder.withDatadogPlugin(process.env.NEXT_PUBLIC_DD_APP_ID!, process.env.NEXT_PUBLIC_DD_CLIENT_TOKEN!);
}

export const bootstrap = builder.build();
